import type { History } from './react-router';
import { createScopedDescriptor } from 'quartz/globalState/api';

export type HistoryBasePath = Readonly<{
  basePathname: string;
  params: Record<string, string>;
}>;

export const HISTORY_INSTANCE = createScopedDescriptor<History>(
  'historyInstance',
  'EXECUTION_CONTEXT'
);

export const HISTORY_BASE_PATH = createScopedDescriptor<HistoryBasePath>(
  'historyBasePath',
  'EXECUTION_CONTEXT'
);

export type GraniteNavigate = (to: string) => void;

/**
 * Cross-app navigator installed by the Granite host, present only while a host
 * is active. BROWSING_CONTEXT (not execution-scoped) so every remote reaches
 * the same one; `navigate()` falls back to app history when it is absent.
 */
export const GRANITE_NAVIGATE = createScopedDescriptor<GraniteNavigate>(
  'graniteNavigate',
  'BROWSING_CONTEXT'
);
